// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.SignUp.View'
    ,	[
        'PageType.Base.View',
        'eureka_maxatrendingproducts_partspicker.tpl'
    ]
    , function (
        PageTypeBaseView,
        eureka_maxatrendingproducts_partspicker_tpl
    )
    {
        'use strict';

        // @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxatrendingproducts_partspicker_tpl

            ,	initialize: function (options) {


            }

            ,beforeShowContent: function beforeShowContent () {
                this.getBreadcrumbPages = function () {
                    return [{
                        text: 'Sign Up',
                        href: ''
                    }];
                };
                return jQuery.Deferred().resolve()

            }

            //@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
            ,	getContext: function getContext()
            {
                return {
                };
            }
        });
    });
